import { RoutePermittedRole } from "shared/constants/AppConst";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";
import Roles from "./roles";
import RoleUpdatIndex from "./roles/RoleUpdate";
import RoleIndex from "./roles/RoleCreate";

export const roleConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageRole",
    exact: true,
    element: isModuleAuthorized("Manage Role") ? <Roles /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageRole/roles",
    exact: true,
    element: isModuleAuthorized("Manage Role") ? <Roles /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageRole/roleCreate",
    exact: true,
    element: isModuleAuthorized("Add Role") ? <RoleIndex /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageRole/roleUpdate/:id",
    exact: true,
    element: isModuleAuthorized("Edit Role") ? <RoleUpdatIndex /> : <Error403 />,
  }
];
